import { Link } from "react-router-dom";
import logo from "./logo.png";

function Navbar(props) {
  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logo} alt="Logo Kasa Accueil"></img>
      </div>

      <div className="navbar__menu">
        <Link
          to="/"
          className={
            props.route === "home"
              ? "navbar__menu__item active"
              : "navbar__menu__item"
          }
        >
          Accueil
        </Link>
        <Link
          to="/about"
          className={
            props.route === "about"
              ? "navbar__menu__item active"
              : "navbar__menu__item"
          }
        >
          A propos
        </Link>
      </div>
    </nav>
  );
}

export default Navbar;
